import { css } from '@emotion/core';
import { typography } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const selectContainerCss = css({
  display: 'block',
  position: 'relative',
});

export const placeholderCss = css({
  pointerEvents: 'none',
  zIndex: 2,
});

export const selectedLabelCss = css(typography.effra18, {
  position: 'relative',
  zIndex: 1,
  minHeight: 68,
  backgroundColor: colorsPalette.white,
  pointerEvents: 'none',
  color: colorsPalette.black,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '25px 16px 9px',
  border: `1px solid ${colorsPalette.grey20}`,

  '&[data-focus="true"]': {
    border: `1px solid ${colorsPalette.teal}`,
  },

  '&[data-error="true"]': {
    border: `1px solid ${colorsPalette.red120}`,
  },

  '&[data-disabled="true"]': {
    border: `1px solid ${colorsPalette.grey20}`,
    background: colorsPalette.grey10,
  },
});

export const labelWithoutPlaceholderCss = css({
  paddingTop: 10,
});
